import type { ImgHTMLAttributes } from 'react';
import media from '@/data/marketingMedia.json';
const dimensions: Record<string, {width:number;height:number}> = media;
export default function MarketingImage(props: ImgHTMLAttributes<HTMLImageElement>) {
  const asset = props.src ? dimensions[props.src] : undefined;
  return <img width={asset?.width} height={asset?.height} loading="lazy" decoding="async" {...props} />;
}
